import { ContentContainer } from "components/ui/display/ContentContainer";
import styled, { useTheme } from "styled-components";
import dragHandleUrl from 'assets/icons/drag_handle_300.svg';
import { Tag } from "components/ui/display/Tag";
import { useDraggable } from "@dnd-kit/react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ProjectsContext } from "providers/ProjectsProvider";
import { getMonthName, parseDuration } from "utilities/dateAndTime";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const TasksKanbanCard = ({task, src = 'tasks'}) => {
    
    const {ref, handleRef} = useDraggable({id: task.taskUuid});
    const navigate = useNavigate();

    const { projects} = useContext(ProjectsContext);
    const taskProject = projects.find(prj => prj.projectUuid === task.taskProjectUuid);

    const checkTaskDelivery = () => {
        if(!task.taskDelivery) return false;
        if(!taskProject.projectDeliveries.enabled) return false;

        const delivery = taskProject.projectDeliveries.deliveries.find(dlv => dlv.deliveryUuid === task.taskDelivery);
        if(!delivery) return;

        return delivery.title;
    }

    const taskDelivery = checkTaskDelivery()

    return (
        <StyledTasksKanbanCard
            ref={ref}
            contentOrientation="row"
            contentGap="md"
            dropShadow="sm"
            onDoubleClick={() => {
                if(src === 'tasks') navigate('/tasks/' + task.taskUuid);
                else if(src === 'projectSettings') navigate('/projects/' + task.taskProjectUuid + '/task/' + task.taskUuid);
            }}
        >
            <div className="dragHandle" ref={handleRef}/>
            <div className="cardContent">
                <div>
                    {task.taskTitle}
                </div>
                <div className="taskInfo">
                    <Tag
                        text={task.taskPriority === 3 ? "Høy" : task.taskPriority === 2 ? "Moderat" : task.taskPriority === 1 ? "Lav" : "Moderat"}
                        type={task.taskPriority === 3 ? "error" : task.taskPriority === 2 ? "warning" : task.taskPriority === 1 ? "success" : "neutral"}
                        icon={<MaterialIcon name='flag' weight={400}/>}
                    />
                    {
                        taskDelivery ? <Tag text={taskDelivery} icon={<MaterialIcon name='package_2' weight={400}/>}/> : null
                    }
                    <div className="attrs">
                        <div className="taskDeadline">
                            <MaterialIcon
                                name='calendar_today'
                                weight={300}
                                size='sm'
                            />
                            {task.taskDeadline.getDate() + " " + getMonthName(task.taskDeadline, true) + "."}
                        </div>
                        <div className="taskDeadline">
                            <MaterialIcon
                                name='schedule'
                                weight={300}
                                size='sm'
                            />
                            {parseDuration(task.taskDuration)}
                        </div>
                    </div>
                </div>
                
            </div>
        </StyledTasksKanbanCard>
    )
}

const StyledTasksKanbanCard = styled(ContentContainer)`

    cursor: pointer;
    user-select: none;
    div.dragHandle
    {
        background-image: url(${dragHandleUrl});
        background-size: 110% auto;
        background-position: top center;
        width: 15px;
        cursor: grab;
        transition-duration: 110ms;
        
        
        opacity: 0.25;

        &:hover
        {
            opacity: 0.5;
        }
    }

    div.cardContent
    {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.md};
    }

    div.taskInfo
    {
        display: flex;
        align-items: center;
        gap: ${({theme}) => theme.spacing.md};
        flex-wrap: wrap;

        div.attrs
        {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: ${({theme}) => theme.spacing.md};
            color: ${({theme}) => theme.colors.mutedForeground};
            font-size: ${({theme}) => theme.fontSize.sm};

            > div
            {
                display: flex;
                align-items: center;
                gap: ${({theme}) => theme.spacing.sm};
                white-space: nowrap;
            }

            svg
            {
                color: ${({theme}) => theme.colors.mutedForeground};
                height: ${({theme}) => theme.iconSize.xs};
                width: ${({theme}) => theme.iconSize.xs};
            }
        }
    }
`

export const TasksEmptyKanbanCard = () => {
    const GlobalTheme = useTheme();
    const color = encodeURIComponent(GlobalTheme.colors.mutedForeground);

    const backgroundBorderUrl = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='${color}' stroke-width='2' stroke-dasharray='10%2c 8' stroke-dashoffset='5' stroke-linecap='square'/%3e%3c/svg%3e")`
    

    return (
        <StyledTasksEmptyKanbanCard $borderImageUrl = {backgroundBorderUrl}>
            Dra oppgave over her.
        </StyledTasksEmptyKanbanCard>
    )
}

const StyledTasksEmptyKanbanCard = styled.div`
    height: 69px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({theme}) => theme.colors.mutedForeground};
    border-radius: ${({theme}) => theme.cornerRadius.md};
    background-image: ${({$borderImageUrl}) => $borderImageUrl};
    user-select: none;
    text-align: center;
    padding: ${({theme}) => theme.spacing.md};
`